// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  StatsTable,AnimatedView,ScoreCard,StatsGraph
}                         from '../../components';

class Customers extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
    })
  };

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Customers');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Customers');
  }

  render() {
    const {
      statsTable,scoreCard,statsGraph,
    } = this.props;
    
    const { 
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;    

    return(
      <AnimatedView>
        <div className="row">
          <div className="col-md-12">
            <ScoreCard name="customers_score_card" data={scoreCard} reloadData={fetchScoreCardDataIfNeeded}/>          
          </div>                  
        </div>
        <div className="row">
          <div className="col-md-12">
            <StatsTable name="customers_summary" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>                  
        </div>              
        <div className="row">
          <div className="col-md-6">
            <StatsTable name="active_customers_per_month" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div> 
          <div className="col-md-6">
            <StatsGraph name="active_customers_per_month_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>                      
          </div>                 
        </div>        
        <div className="row">
          <div className="col-md-12">
            <StatsTable bigTable={true} name="all_customers_list" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>        
        </div>

      </AnimatedView>
    );
  }
}

export default Customers;



// WEBPACK FOOTER //
// ./src/app/views/customers/Customers.js